import { useContext } from "react";
import { Route, Routes } from "react-router-dom";
import { ThemeContext } from "./contexts";

import AboutUs from "./Components/AboutUs";
import Courses from "./Components/Courses";
import Footer from "./Components/Footer";
import Header from "./Components/Header";
import Home from "./Components/Home";
import ForgotPassword from "./Components/Login/ForgotPassword";
import Login from "./Components/Login/Login";
import RequireAssistant from "./Components/Login/RequireAssistant";
import SignUp from "./Components/Login/SignUp";
import NotFound from "./Components/NotFound";
import Aqeedah from "./Components/NoticeBoard/Aqeedah/Aqeedah";
import AqeedahDetails from "./Components/NoticeBoard/Aqeedah/AqeedahDetails";
import AqeedahResultPage from "./Components/NoticeBoard/Aqeedah/AqeedahResultPage";
import NewRegAsmaulHusna from "./Components/NoticeBoard/AsmaulHusna/Registration/NewRegAsmaulHusna";
import NoticeBoard from "./Components/NoticeBoard/NoticeBoard";
import PaymentOverviewPage from "./Components/NoticeBoard/Payment/PaymentOverview/PaymentOverviewPage.js";
import Registration from "./Components/Registration";
import Schedule from "./Components/Schedule/Schedule";
import WebinarRegistration from "./Components/Webinars/Registration/WebinarRegistration";
// import Aqeedah3ResultUpdate from './Components/NoticeBoard/Aqeedah/Aqeedah3ResultUpdate';
import AqeedahDue from "./Components/NoticeBoard/Aqeedah/Registration/AqeedahDue.js";
import PaymentDue from "./Components/NoticeBoard/Payment/PaymentDue.js";

import AqeedahRegistration from "./Components/NoticeBoard/Aqeedah/Registration/AqeedahRegistration";
import NewRegAqeedah from "./Components/NoticeBoard/Aqeedah/Registration/NewRegAqeedah";
import DuaAdminAccess from "./Components/NoticeBoard/Dua/DuaResultPage/DuaAdminAccess";

import RequireAdmin from "./Components/Login/RequireAdmin";
import ReqiureAuth from "./Components/Login/RequireAuth";

import AlQuranInfo from "./Components/NoticeBoard/AlQuran/AlQuranInfo";
import AqeedahInfo from "./Components/NoticeBoard/Aqeedah/AqeedahInfo";
import Aqeedah1LeaderBoard from "./Components/NoticeBoard/Aqeedah/LeaderBoard/Aqeedah1LeaderBoard";
import Arabic from "./Components/NoticeBoard/Arabic/Arabic";
import ArabicInfo from "./Components/NoticeBoard/Arabic/ArabicInfo";
import ArabicDetails from "./Components/NoticeBoard/Arabic/ArabicResultPage/ArabicDetails";
import ArabicResultPage from "./Components/NoticeBoard/Arabic/ArabicResultPage/ArabicResultPage";
import ArabicRegistration from "./Components/NoticeBoard/Arabic/Registration/ArabicRegistration";
import ArabicUpdaterPage from "./Components/NoticeBoard/Arabic/Registration/ArabicUpdaterPage";
import AsmaulHusnaInfo from "./Components/NoticeBoard/AsmaulHusna/AsmaulHusnaInfo";
import AsmaulHusnaAdminAccess from "./Components/NoticeBoard/AsmaulHusna/AsmaulHusnaResult/AsmaulHusnaAdminAccess";
import AsmaulHusnaResultPage from "./Components/NoticeBoard/AsmaulHusna/AsmaulHusnaResult/AsmaulHusnaResultPage";
import AsmaulHusna1LeaderBoard from "./Components/NoticeBoard/AsmaulHusna/Leaderboard/AsmaLeaderboard";
import DuaInfo from "./Components/NoticeBoard/Dua/DuaInfo";
import DuaRegistration from "./Components/NoticeBoard/Dua/Registration/DuaRegistration";
import Fiqh from "./Components/NoticeBoard/Fiqh/Fiqh";
import FiqhInfo from "./Components/NoticeBoard/Fiqh/FiqhInfo";
import FiqhDetails from "./Components/NoticeBoard/Fiqh/FiqhResult/FiqhDetails";
import FiqhResultPage from "./Components/NoticeBoard/Fiqh/FiqhResult/FiqhResultPage";
import FiqhLeaderboard from "./Components/NoticeBoard/Fiqh/LeaderBoard/FiqhLeaderboard";

import SeeratInfo from "./Components/NoticeBoard/Seerat/SeeratInfo";
import TafseerRegistration from "./Components/NoticeBoard/Tafseer/Registration/TafseerRegistration";
import TafseerInfo from "./Components/NoticeBoard/Tafseer/TafseerInfo";
import TajweedLeaderboard from "./Components/NoticeBoard/Tajweed/LeaderBoard/TajweedLeaderboard";
import TajweedRegistration from "./Components/NoticeBoard/Tajweed/Registration/TajweedRegistration";
import Tajweed from "./Components/NoticeBoard/Tajweed/Tajweed";
import TajweedInfo from "./Components/NoticeBoard/Tajweed/TajweedInfo";
import TajweedDetails from "./Components/NoticeBoard/Tajweed/TajweedResult/TajweedDetails";
import TajweedResultPage from "./Components/NoticeBoard/Tajweed/TajweedResult/TajweedResultPage";
import AddReview from "./Components/Reviews/AddReview";
import AqeedahReviews from "./Components/Reviews/AqeedahReviews";

import SeeratLeaderboard from "./Components/NoticeBoard/Seerat/LeaderBoard/SeeratLeaderboard";
import SeeratRegistration from "./Components/NoticeBoard/Seerat/Registration/SeeratRegistration";
import Seerat from "./Components/NoticeBoard/Seerat/Seerat";
import SeeratDetails from "./Components/NoticeBoard/Seerat/SeeratResult/SeeratDetails";
import SeeratResultPage from "./Components/NoticeBoard/Seerat/SeeratResult/SeeratResultPage";

import RamadanLeaderboard from "./Components/NoticeBoard/RamadanSiyam/LeaderBoard/RamadanLeaderboard";
import RamadanDetails from "./Components/NoticeBoard/RamadanSiyam/RamadanResult/RamadanDetails";
import RamadanSiyamResultPage from "./Components/NoticeBoard/RamadanSiyam/RamadanResult/RamadanSiyamResultPage";
import RamadanSiyam from "./Components/NoticeBoard/RamadanSiyam/RamadanSiyam";
import RamadanSiyamInfo from "./Components/NoticeBoard/RamadanSiyam/RamadanSiyamInfo";
import RamadanRegistration from "./Components/NoticeBoard/RamadanSiyam/Registration/RamadanRegistration";

import TafseerLeaderboard from "./Components/NoticeBoard/Tafseer/LeaderBoard/TafseerLeaderboard";
import Tafseer from "./Components/NoticeBoard/Tafseer/Tafseer";
import TafseerDetails from "./Components/NoticeBoard/Tafseer/TafseerResult/TafseerDetails";
import TafseerResultPage from "./Components/NoticeBoard/Tafseer/TafseerResult/TafseerResultPage";
import Office from "./Components/Office";

import CertificateNameQuery from "./Components/CertificateNameQuery/CertificateNameQuery";
import Donation from "./Components/Donation/Donation";
import RequireModerator from "./Components/Login/RequireModerator";
import TelegramBotMessage from "./Components/Message/TelegramBotMessage";
import MessengerPlugin from "./Components/MessengerPlugin";
import MeritList from "./Components/NoticeBoard/Aqeedah/LeaderBoard/MeritList";
import AsmaulHusna from "./Components/NoticeBoard/AsmaulHusna/AsmaulHusna";
import AsmaulHusnaDetails from "./Components/NoticeBoard/AsmaulHusna/AsmaulHusnaResult/AsmaulHusnaDetails";
import AsmaulHusnaRegistration from "./Components/NoticeBoard/AsmaulHusna/Registration/AsmaulHusnaRegistration";
import Dua from "./Components/NoticeBoard/Dua/Dua";
import DuaDetails from "./Components/NoticeBoard/Dua/DuaResultPage/DuaDetails";
import DuaResultPage from "./Components/NoticeBoard/Dua/DuaResultPage/DuaResultPage";
import NewRegDua from "./Components/NoticeBoard/Dua/Registration/NewRegDua";
import ScholarshipBoard from "./Components/Scholarship/ScholarshipBoard";
import ScholarshipDetails from "./Components/Scholarship/ScholarshipDetails";
import ScholarshipList from "./Components/Scholarship/ScholarshipList";
import ScholarshipUpdater from "./Components/Scholarship/Updater/ScholarshipUpdater";
import ResultUpdater from "./Components/Updater/ResultUpdater";
import StudentImport from "./Components/Updater/StudentImport";

import FiqhRegistration from "./Components/NoticeBoard/Fiqh/Registration/FiqhRegistration";
import WebinarLeaderboard from "./Components/Webinars/LeaderBoard/WebinarLeaderboard";
import WebinarDetails from "./Components/Webinars/WebinarResult/WebinarDetails";
import WebinarResultPage from "./Components/Webinars/WebinarResult/WebinarResultPage";

import SpreadsheetoToReact from "./Components/NoticeBoard/Aqeedah/GoogleSpreadsheet/SpreadsheetoToReact";
import Webinars from "./Components/Webinars/Webinars";
import usePageTracking from "./GTM/usePageTracking";

import Spreadsheets from "./Components/Spreadsheet/Spreadsheets";

export default function Page() {
  const { darkMode } = useContext(ThemeContext);
  usePageTracking();
  return (
    <div className={`${darkMode ? "dark" : ""}`}>
      <Header></Header>
      <div className="w-full">
        <MessengerPlugin></MessengerPlugin>
      </div>
      <Routes>
        <Route path="" element={<Home />}></Route>
        <Route path="courses" element={<Courses />}></Route>
        <Route path="courses/aqeedah" element={<AqeedahInfo />}></Route>
        <Route path="courses/arabic" element={<ArabicInfo />}></Route>
        <Route path="courses/dua" element={<DuaInfo />}></Route>
        <Route path="courses/fiqh" element={<FiqhInfo />}></Route>
        <Route path="courses/tafseer" element={<TafseerInfo />}></Route>
        <Route path="courses/seerat" element={<SeeratInfo />}></Route>
        <Route path="courses/tajweed" element={<TajweedInfo />}></Route>
        <Route path="courses/alquran" element={<AlQuranInfo />}></Route>
        <Route
          path="courses/asmaul-husna"
          element={<AsmaulHusnaInfo />}
        ></Route>

        <Route
          path="payment-overview-:course/:batch"
          element={
            <ReqiureAuth>
              <RequireAdmin>
                <PaymentOverviewPage />
              </RequireAdmin>
            </ReqiureAuth>
          }
        ></Route>
        <Route path="payment-due" element={<PaymentDue />}></Route>

        <Route path="tajweed" element={<Tajweed />}></Route>
        <Route path="tajweed-due" element={<AqeedahDue />}></Route>
        <Route path="tajweed-:batch" element={<TajweedResultPage />}></Route>
        <Route path="tajweed-:batch/:sn" element={<TajweedDetails />}></Route>
        <Route
          path="leaderboard:level-tajweed-:batch/:sn"
          element={<TajweedLeaderboard />}
        ></Route>
        <Route
          path="registration-asmaul-husna"
          element={<AsmaulHusnaRegistration />}
        ></Route>
        <Route path="asmaul-husna" element={<AsmaulHusna />}></Route>
        <Route path="asmaul-husna-due" element={<AqeedahDue />}></Route>
        <Route
          path="asmaul-husna-admin-access-:batch"
          element={
            <ReqiureAuth>
              <RequireAssistant>
                <AsmaulHusnaAdminAccess />
              </RequireAssistant>
            </ReqiureAuth>
          }
        ></Route>
        <Route
          path="asmaul-husna-:batch"
          element={<AsmaulHusnaResultPage />}
        ></Route>
        <Route
          path="asmaul-husna-:batch/:sn"
          element={<AsmaulHusnaDetails />}
        ></Route>
        <Route
          path="new-asmaul-husna-registration"
          element={
            <ReqiureAuth>
              <RequireAdmin>
                <NewRegAsmaulHusna />
              </RequireAdmin>
            </ReqiureAuth>
          }
        ></Route>
        <Route
          path="leaderboard:level-asmaul-husna-:batch/:sn"
          element={<AsmaulHusna1LeaderBoard />}
        ></Route>
        <Route
          path="registration-tajweed"
          element={<TajweedRegistration />}
        ></Route>
        <Route path="ramadan-siyam" element={<RamadanSiyam />}></Route>
        <Route
          path="ramadan-siyam-:batch"
          element={<RamadanSiyamResultPage />}
        ></Route>
        <Route
          path="ramadan-siyam-:batch/:sn"
          element={<RamadanDetails />}
        ></Route>
        <Route
          path="courses/ramadan-siyam"
          element={<RamadanSiyamInfo />}
        ></Route>
        <Route
          path="leaderboard:level-ramadan-siyam-:batch/:sn"
          element={<RamadanLeaderboard />}
        ></Route>
        <Route
          path="registration-ramadan-siyam"
          element={<RamadanRegistration />}
        ></Route>

        <Route path="noticeboard" element={<NoticeBoard />}></Route>
        <Route path="aqeedah" element={<Aqeedah />}></Route>
        <Route path="aqeedah-due" element={<AqeedahDue />}></Route>
        <Route path="aqeedah-:batch" element={<AqeedahResultPage />}></Route>
        <Route path="aqeedah-:batch/:sn" element={<AqeedahDetails />}></Route>
        <Route
          path="meritlist-aqeedah-:batch/:sn"
          element={<MeritList />}
        ></Route>
        <Route
          path="leaderboard-aqeedah1-:batch/:sn"
          element={<Aqeedah1LeaderBoard />}
        ></Route>
        <Route
          path="spreadsheet-to-react"
          element={<SpreadsheetoToReact />}
        ></Route>
        <Route path="fiqh" element={<Fiqh />}></Route>
        <Route path="fiqh-due" element={<AqeedahDue />}></Route>
        <Route path="fiqh-:batch" element={<FiqhResultPage />}></Route>
        <Route path="fiqh-:batch/:sn" element={<FiqhDetails />}></Route>
        <Route
          path="leaderboard:level-fiqh-:batch/:sn"
          element={<FiqhLeaderboard />}
        ></Route>
        <Route path="registration-fiqh" element={<FiqhRegistration />}></Route>
        <Route path="seerat" element={<Seerat />}></Route>
        <Route path="seerat-due" element={<AqeedahDue />}></Route>
        <Route path="seerat-:batch" element={<SeeratResultPage />}></Route>
        <Route path="seerat-:batch/:sn" element={<SeeratDetails />}></Route>
        <Route
          path="leaderboard:level-seerat-:batch/:sn"
          element={<SeeratLeaderboard />}
        ></Route>
        <Route
          path="registration-seerat"
          element={<SeeratRegistration />}
        ></Route>

        <Route path="tafseer" element={<Tafseer />}></Route>
        <Route path="tafseer-due" element={<AqeedahDue />}></Route>
        <Route path="tafseer-:batch" element={<TafseerResultPage />}></Route>
        <Route path="tafseer-:batch/:sn" element={<TafseerDetails />}></Route>
        <Route
          path="registration-tafseer"
          element={<TafseerRegistration />}
        ></Route>
        <Route
          path="leaderboard:level-tafseer-:batch/:sn"
          element={<TafseerLeaderboard />}
        ></Route>
        <Route
          path="dua-admin-access-:batch"
          element={
            <ReqiureAuth>
              <RequireAssistant>
                <DuaAdminAccess />
              </RequireAssistant>
            </ReqiureAuth>
          }
        ></Route>
        <Route path="dua" element={<Dua />}></Route>
        <Route path="dua-due" element={<AqeedahDue />}></Route>
        <Route path="dua-:batch" element={<DuaResultPage />}></Route>
        <Route path="dua-:batch/:sn" element={<DuaDetails />}></Route>
        <Route
          path="new-dua-registration"
          element={
            <ReqiureAuth>
              <RequireAdmin>
                <NewRegDua />
              </RequireAdmin>
            </ReqiureAuth>
          }
        ></Route>

        {/* <Route path='aqeedah-14/:sn/update-result' element={<RequireAdmin><Aqeedah3ResultUpdate></Aqeedah3ResultUpdate></RequireAdmin>}></Route> */}
        <Route path="reviews" element={<AqeedahReviews />}></Route>
        <Route path="add-review" element={<AddReview />}></Route>
        <Route path="arabic" element={<Arabic />}></Route>
        <Route path="arabic-:batch" element={<ArabicResultPage />}></Route>
        <Route path="arabic-:batch/:sn" element={<ArabicDetails />}></Route>
        <Route path="about-us" element={<AboutUs />}></Route>
        <Route path="schedule" element={<Schedule></Schedule>}></Route>
        <Route path="registration" element={<Registration />}></Route>
        <Route
          path="new-aqeedah-registration"
          element={
            <ReqiureAuth>
              <RequireAdmin>
                <NewRegAqeedah />
              </RequireAdmin>
            </ReqiureAuth>
          }
        ></Route>
        <Route
          path="new-arabic-registration"
          element={
            <ReqiureAuth>
              <RequireAdmin>
                <ArabicUpdaterPage />
              </RequireAdmin>
            </ReqiureAuth>
          }
        ></Route>
        <Route
          path="result-update"
          element={
            <ReqiureAuth>
              <RequireAdmin>
                <ResultUpdater></ResultUpdater>
              </RequireAdmin>
            </ReqiureAuth>
          }
        ></Route>
        <Route
          path="office"
          element={
            <ReqiureAuth>
              <RequireAdmin>
                <Office></Office>
              </RequireAdmin>
            </ReqiureAuth>
          }
        ></Route>
        <Route
          path="spreadsheets"
          element={
            <ReqiureAuth>
              <RequireModerator>
                <Spreadsheets></Spreadsheets>
              </RequireModerator>
            </ReqiureAuth>
          }
        ></Route>
        <Route
          path="scholarship/"
          element={
            <ReqiureAuth>
              <RequireModerator>
                <ScholarshipBoard></ScholarshipBoard>
              </RequireModerator>
            </ReqiureAuth>
          }
        ></Route>
        <Route
          path="scholarship/:course"
          element={
            <ReqiureAuth>
              <RequireModerator>
                <ScholarshipList></ScholarshipList>
              </RequireModerator>
            </ReqiureAuth>
          }
        ></Route>
        <Route
          path="scholarship/:course/:sn"
          element={
            <ReqiureAuth>
              <RequireModerator>
                <ScholarshipDetails></ScholarshipDetails>
              </RequireModerator>
            </ReqiureAuth>
          }
        ></Route>
        <Route
          path="scholarship/updater"
          element={
            <ReqiureAuth>
              <RequireModerator>
                <ScholarshipUpdater></ScholarshipUpdater>
              </RequireModerator>
            </ReqiureAuth>
          }
        ></Route>
        <Route
          path="telegram-bot"
          element={
            <ReqiureAuth>
              <RequireAdmin>
                <TelegramBotMessage />
              </RequireAdmin>
            </ReqiureAuth>
          }
        ></Route>
        <Route
          path="registration-aqeedah"
          element={<AqeedahRegistration />}
        ></Route>
        <Route
          path="registration-arabic"
          element={<ArabicRegistration />}
        ></Route>
        <Route path="registration-dua" element={<DuaRegistration />}></Route>

        <Route path="webinar-:batch" element={<WebinarResultPage />}></Route>
        <Route path="webinar-:batch/:sn" element={<WebinarDetails />}></Route>
        <Route
          path="leaderboard:level-webinar-:batch/:sn"
          element={<WebinarLeaderboard />}
        ></Route>

        <Route path="webinars" element={<Webinars />}></Route>
        <Route
          path="registration-webinar"
          element={<WebinarRegistration />}
        ></Route>
        <Route
          path="all-student-names"
          element={<CertificateNameQuery />}
        ></Route>

        <Route path="student-import" element={<StudentImport />}></Route>
        <Route path="donation" element={<Donation />}></Route>

        <Route path="login" element={<Login />}></Route>
        <Route path="signup" element={<SignUp />}></Route>
        <Route path="forgot-password" element={<ForgotPassword />}></Route>
        <Route path="*" element={<NotFound />}></Route>
      </Routes>
      <Footer></Footer>
    </div>
  );
}
